import api from "../../system/api";
import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";

export default class Home extends BaseStrapiCollection {
    constructor() {
        super("collectionType", "home", "home");
    }

    async getHome(workspaceId) {
        return this.action("", `/workspaces/${encodeURIComponent(workspaceId)}/home`, workspaceId);
    }

    // The focus calls answer with codes (FOCUS_LIMIT_REACHED …) that the home page turns into a message the member
    // can act on; the global handler would print the raw code next to it (boss's bug report 2026-11-02).
    async addFocusItem(workspaceId, taskId, expectedVersion) {
        try {
            await this.waitForWorkspace(workspaceId);
            const response = await api.post(
                `/workspaces/${encodeURIComponent(workspaceId)}/focus-items`,
                {data: {taskId, expectedVersion}},
                {...this.getHeader(workspaceId), suppressGlobalErrorHandler: true},
            );
            return response.data;
        } catch (error) {
            throw this._normalizeError(error);
        }
    }

    async reorderFocusItems(workspaceId, orderedFocusItemIds, expectedVersion) {
        try {
            await this.waitForWorkspace(workspaceId);
            const response = await api.patch(
                `/workspaces/${encodeURIComponent(workspaceId)}/focus-items/reorder`,
                {data: {orderedFocusItemIds, expectedVersion}},
                {...this.getHeader(workspaceId), suppressGlobalErrorHandler: true},
            );
            return response.data;
        } catch (error) {
            throw this._normalizeError(error);
        }
    }

    async removeFocusItem(workspaceId, focusItemId, expectedVersion) {
        try {
            await this.waitForWorkspace(workspaceId);
            const response = await api.delete(
                `/workspaces/${encodeURIComponent(workspaceId)}/focus-items/${encodeURIComponent(focusItemId)}`,
                {
                    ...this.getHeader(workspaceId),
                    params: {expectedVersion},
                    suppressGlobalErrorHandler: true,
                },
            );
            return response.data;
        } catch (error) {
            throw this._normalizeError(error);
        }
    }

    async startFocusSession(workspaceId, taskId, targetDurationSeconds) {
        return this.postAction(
            `/workspaces/${encodeURIComponent(workspaceId)}/focus-sessions/start`,
            {taskId, targetDurationSeconds, expectedVersion: 0},
            {},
            workspaceId,
        );
    }

    async getCurrentFocusSession(workspaceId) {
        return this.action(
            "",
            `/workspaces/${encodeURIComponent(workspaceId)}/focus-sessions/current`,
            workspaceId,
        );
    }

    async getActiveFocusSessions(workspaceId) {
        return this.action(
            "",
            `/workspaces/${encodeURIComponent(workspaceId)}/focus-sessions/active`,
            workspaceId,
        );
    }

    async mutateFocusSession(workspaceId, sessionId, action, expectedVersion, data = {}) {
        const url = `/workspaces/${encodeURIComponent(workspaceId)}/focus-sessions/${encodeURIComponent(sessionId)}/${action}`;
        try {
            await this.waitForWorkspace(workspaceId);
            const method = action === "note" ? "patch" : "post";
            const response = await api[method](
                url,
                {data: {...data, expectedVersion}},
                this.getHeader(workspaceId),
            );
            return response.data;
        } catch (error) {
            throw this._normalizeError(error);
        }
    }
}
